function promiseBuilder (responseName) {
  let response = JSON.parse(JSON.stringify(require('./' + responseName + '.json')))
  console.log('call promise ' + responseName, response)
  return new Promise((resolve, reject) => { resolve({ 'data': response }) }) /* key 'data' para simular axios response */
}

export default promiseBuilder
